import userTypes from 'constants/userTypes';

export default [
  userTypes.PARTNER,
  userTypes.BENEFICIARY,
  userTypes.BENEFICIARY_DRAFT,
];
